module.exports = __webpack_public_path__ + "static/media/food.934b26d0.jpg";